import { debounce } from "lodash";
import { useCallback, useState } from "react";
import { fetchDropDownData } from "../fetchDropDownData";
import { queries } from "@testing-library/dom";

export const GrnUtils = () => {
    const [supplierOptions, setSupplierOptions] = useState<any[]>([]);
    const [supplierParts, setSupplierParts] = useState<any[]>([]);

    const [purchaseNoOptions,setPurchaseNoOptions] = useState<any[]>([]);
    const [partNoOptions,setPartNoOptions] = useState<any[]>([]);

    const fetchSupplierOptions = useCallback(
        debounce((inputValue) => {
            fetchDropDownData({
                endpoint: "/contributors",
                searchKey: "code",
                searchTerm: inputValue,
                labelKey: "code",
                valueKey: "_id",
            }).then((data) => {

                const filteredSuppliers = data.filter(
                    (supplier: any) => supplier.type === "SUPPLIER" || supplier.type === "CUSTOMER&SUPPLIER"
                );

                const formattedSuppliers = filteredSuppliers.map((supplier: any) => ({
                    label: supplier.code, 
                    value: supplier._id, 
                }));
                setSupplierOptions(formattedSuppliers);
            });
        }, 500),
        []
    );

    const fetchSupplierParts = async (supplierId: string) => {
        try {
            const data : any = await fetchDropDownData({
                endpoint: "/supplierparts", 
                searchKey: "supplierId",    
                searchTerm: supplierId,
                labelKey: "supplierId",       
                valueKey: "_id",           
            });

            console.log("supplier parts response from grnutils",data);
            
            return data;
        } catch (error) {
            console.error("Error fetching supplier parts:", error);
        }
    };

    const fetchOnSearchPartDetails = async (inputvalue:string) => {
        try {
            const data : any = await fetchDropDownData({
                endpoint: "/supplierparts", 
                searchKey: "partDetails.internalPartNo",    
                searchTerm: inputvalue,
                labelKey: "partDetails.internalPartNo",       
                valueKey: "partDetails._id",           
            });

            console.log("supplier parts response from grnutils",data);

            return data;
        } catch (error) {
            console.error("Error fetching supplier parts:", error);
        }
    }

    const fetchPoNumber = async(inputValue:string) => {
        try{
            const data:any = await fetchDropDownData({
                endpoint:"/purchase-orders/unique",
                searchKey:"poNumber",
                searchTerm:inputValue,
                labelKey:"poNumber",
                valueKey:"_id"
            })

            const formattedData = data.map((po:any) => ({
                label:po.poNumber,
                value:po.poNumber,
                supplierCode: po.supplierDetails.code,  
                supplierId:po.supplierId,
                balanceQty:po.balanceQty
            }))
            
            setPurchaseNoOptions(formattedData);
        }catch (error) {
            console.error("Error fetching purchase order:", error);
        }
    }

    const fetchPartNumbers = async(inputValue:string) => {
        try{
            const data:any = await fetchDropDownData({
                endpoint:"/purchase-orders",
                searchKey:"poNumber",
                searchTerm:inputValue,
                labelKey:"parts.internalPartNo",
                valueKey:"parts._id"
            })

            const formattedResponse = data.map((part:any) =>({
                label:part.parts.internalPartNo,
                value:part.supplier._id,
                partName:part.parts.partName,
                unitPrice:part.supplier.unitPrice,
                model:part.parts.modelId.name,
                category:part.parts.categoryId.name,
                uom:part.parts.uomId.name,
                packingQty:part.parts.packingQty,
                poQty:part.qty,
                balanceQty:part.balanceQty
            }))

            console.log("partNo Options: ",formattedResponse);
            return formattedResponse
            
        }catch (error) {
            console.error("Error fetching purchase order:", error);
        }
    }

    const fetchOnSearchPartNumbers = async(inputValue:string,poNumber:string) => {
        console.log("queries: ",inputValue,poNumber);
        
        try{
            const data:any = await fetchDropDownData({
                endpoint:"/purchase-orders",
                searchKey:"parts.internalPartNo",
                searchTerm:inputValue,
                labelKey:"parts.internalPartNo",
                valueKey:"parts._id",
                poNumber:poNumber
            })
            console.log("partno options: ",data);

            const formattedResponse = data.map((part:any) =>({
                label:part.parts.internalPartNo,
                value:part.supplier._id,
                partName:part.parts.partName,
                unitPrice:part.supplier.unitPrice,
                model:part.parts.modelId.name,
                category:part.parts.categoryId.name,
                uom:part.parts.uomId.name,
                packingQty:part.parts.packingQty,
                poQty:part.qty,
                balanceQty:part.balanceQty

            }))

            setPartNoOptions(formattedResponse)

            return formattedResponse
           
        }catch (error) {
            console.error("Error fetching purchase order:", error);
        }
    }



    return {
        supplierOptions,
        setSupplierOptions,
        fetchSupplierOptions,
        supplierParts,
        setSupplierParts,
        fetchSupplierParts,
        fetchOnSearchPartDetails,
        purchaseNoOptions,
        fetchPoNumber,
        partNoOptions,
        fetchPartNumbers,
        fetchOnSearchPartNumbers
    };
};
